module.exports = __webpack_public_path__ + "static/media/icon.2df4663e.png";